import { Nullable } from '@heidi-pay/heidi-common-fe/types';
import { objectKeysToCamelCase } from '@heidi-pay/heidi-common-fe/utils/objectKeysToCamelCase';
import { IMerchantPortalApplicationsExtraData } from '@schemas/merchantPortal/types/applicationsExtraData';

const getBoolString = (value: boolean | undefined) =>
  value === undefined ? value : value.toString();

interface IGetApplicationUploadStatus {
  applicationIsSuccessful: boolean;
  externalContractUuid: Nullable<string> | undefined;
  extraData: IMerchantPortalApplicationsExtraData | undefined;
}

export const getApplicationUploadStatus = ({
  applicationIsSuccessful,
  externalContractUuid,
  extraData,
}: IGetApplicationUploadStatus) => {
  const { applications } = objectKeysToCamelCase(extraData) ?? {};
  const application = applications?.find(
    app => app.externalContractUuid === externalContractUuid,
  );

  const summary = application?.applicationDocumentUploadSummary;
  const signingOverview = summary?.customerAgreementSigningOverview;
  const identitySummary = summary?.manualIdentityUploadSummary;

  const hasSignedContract =
    signingOverview?.hasUploadedSignedAgreement ||
    (applicationIsSuccessful && !signingOverview?.isManualSigningRequired);

  const hasUploadedId =
    identitySummary?.hasIdentityDocumentBeenUploaded ||
    (applicationIsSuccessful &&
      !identitySummary?.isManualIdentityDocumentUploadRequired);

  return {
    hasUploadedId: getBoolString(identitySummary && hasUploadedId),
    hasSignedContract: getBoolString(signingOverview && hasSignedContract),
  };
};
